export default __webpack_public_path__ + "static/overall-bfb5a04186101ed85d76b8760ad1414e.mp4";